import type MarketSelectionProperties from './MarketSelection.properties.ts';
import type { MarketMarketIO } from '../../generated/fresh-guard-api';
import { useEditMarket } from '../../provider/edit-market/EditMarket.hook.ts';

export const useMarketSelectionController = (props: MarketSelectionProperties) => {
  const { markets } = useEditMarket();

  const handleMarketSelectionChanged = (market: MarketMarketIO) => {
    props.onChange(market);
  };

  const handleMarketSelectionChangedMobile = (value: string) => {
    if (props.setIsBurgerMenuOpen) {
      props.setIsBurgerMenuOpen(false);
    }

    const market = markets.find((market) => market.id?.toString() === value);

    if (market) {
      handleMarketSelectionChanged(market);
    }
  };

  return {
    handleMarketSelectionChanged,
    handleMarketSelectionChangedMobile,
    markets,
  };
};
